export const ADD_MESSAGE_ACTION = 'addMessageAction';
export const REMOVE_MESSAGE_ACTION = 'removeMessageAction';
export const CLEAR_MESSAGES_ACTION = 'clearMessagesAction';
export const TOGGLE_LOADING_ACTION = 'toggleLoadingAction';
export const TOGGLE_MODAL_ACTION = 'toggleModalAction';
export const ADD_MEDIA_ACTION = 'addMediaAction';
export const ADD_MEDIA_SELLING_POINT_ACTION = 'addMediaSellingPointAction';
export const ADD_MEDIA_INTERNATIONAL_ACTION = 'addMediaInternationalAction';
